import React from 'react';
import styles from './MobileMediaFilter.module.scss';
import BaseMediaFilter from './BaseMediaFilter';

const MobileMediaFilter = () => <BaseMediaFilter styles={styles} />;

export default MobileMediaFilter;
